import React, { useContext } from 'react';
import styled from 'styled-components';
import Toast from 'react-bootstrap/Toast';
import { ContextAlert } from '../context/ContextAlert';


const ContainerAlert = styled.div `
    z-index: 1000;
    width: 100%;
    left: 0;
    top: 80px;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;

    @media(max-width: 60rem){
        top: 20px;
}
`


const Alert = ({message, type, header}) => {
    const {show, handleClose} = useContext(ContextAlert);
    
    return ( 
    <>
    <ContainerAlert>
        <Toast 
        bg = {type}
        onClose={handleClose} 
        show={show} 
        delay={3000} 
        autohide>
          <Toast.Header>
            <strong className="me-auto">{header}</strong>
          </Toast.Header>
          <Toast.Body>{message}</Toast.Body>
        </Toast>
    </ContainerAlert>
    </>

     );
}
 
export default Alert;